import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      // Constantes globais
      let cartId = null;
      const CONFIG = {
        API_HEADERS: { 'Content-Type': 'application/json' },
        CART_ENDPOINT: '/api/front/cart/items/?version=2',
        SELECTORS: {
          cartPreview: '.cart-preview',
          shippingOverlay: '.cart-preview__shipping--overlay',
          shipping: '.cart-preview__shipping',
          shippingClose: '.cart-preview__shipping--close',
          itemsList: '.cart_preview-items',
          subtotal: '.cart-preview__sub-total--value',
          discounts: '.cart-preview__discounts--value',
          total: '.cart-preview__total--value',
          counters: '.quant_itens_carrinho',
          footer: '.cart-preview__footer',
          footerUtils: '.cart-preview__footer-utils',
          openUtils: '.open-utils',
          couponInput: '#appendedInputButton',
          removeCoupon: '#removeCoupon',
          shippingForm: '#js_form_shipping_cep_cart_lateral',
          cepInput: '#js_cep_input_cart_lateral',
          shippingList: '.cart-preview__shipping__list',
          selectedShipping: '.selected-shipping',
          // Seletores para a barra de progresso do frete grátis
          freeShippingBar: '.cart-preview-free-shipping__bar--percent',
          freeShippingValueFrom: '.cart-preview-free-shipping__value-from',
          freeShippingValueTo: '.cart-preview-free-shipping__value-to',
          freeShippingTip: '.cart-preview-free-shipping__tip'
        }
      };
      const handleZipCode = (event) => {
        let input = event.target;
        input.value = zipCodeMask(input.value);
      }

      const zipCodeMask = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
        return value;
      }
      const cepInput = document.querySelector('.cart-preview #js_form_shipping_cep_cart');
      if (cepInput) {
        cepInput.addEventListener('keyup', handleZipCode);
      }
      // Adiciona máscara para o input lateral também
      const cepInputLateral = document.querySelector(CONFIG.SELECTORS.cepInput);
      if (cepInputLateral) {
        cepInputLateral.addEventListener('keyup', handleZipCode);
      }


      // Funções utilitárias
      const utils = {
        formatCurrency: value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value),

        toggleClasses: (selectors, className, add = true) => {
          selectors.forEach(selector => $(selector)[add ? 'addClass' : 'removeClass'](className));
        },

        ajaxRequest: (method, url, data, headers = CONFIG.API_HEADERS) => {
          // Garantir que URLs de DELETE sempre tenham barra no final para evitar problemas no iOS 16.1
          let normalizedUrl = url;
          if (method === 'DELETE' && !url.endsWith('/')) {
            normalizedUrl = url + '/';
          }

          return $.ajax({
            type: method,
            url: normalizedUrl,
            headers,
            dataType: 'json',
            data: typeof data === 'object' ? JSON.stringify(data) : data
          });
        },

        updateFooterUtilsHeight: (first) => {
          const utils = document.querySelector(CONFIG.SELECTORS.footerUtils);
          if (utils) {
            utils.querySelectorAll('li').forEach(li => {
              const append = li.querySelector('.input-append');
              if (append) {
                const form = append.querySelector('form');
                const list = append.querySelector('.cart-preview__shipping__list');

                let totalHeight = 0;
                if (form) totalHeight += form.getBoundingClientRect().height;
                if (list) {
                  totalHeight += list.children.length > 0 ? 145 : 0;
                }

                append.style.height = `${totalHeight + 20}px`; // +20px de espaçamento
              }

              if (first) {
                li.classList.add('active');
              }
            });
          }
        },

        // Função para atualizar a barra de progresso do frete grátis
        updateFreeShippingProgress: (currentValue, targetValue, freeShippingLabel, freeShippingLabelSuccess) => {
          const { SELECTORS } = CONFIG;

          // Converter valores para números
          const current = parseFloat(currentValue) || 0;
          const target = parseFloat(targetValue) || 0;

          // Calcular a porcentagem
          let percentage = 0;
          if (target > 0) {
            percentage = Math.min((current / target) * 100, 100);
          }

          // Atualizar a barra de progresso
          const progressBar = document.querySelector(SELECTORS.freeShippingBar);
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }

          // Atualizar os valores exibidos
          const valueFrom = document.querySelector(SELECTORS.freeShippingValueFrom);
          const valueTo = document.querySelector(SELECTORS.freeShippingValueTo);

          if (valueFrom) {
            valueFrom.textContent = utils.formatCurrency(current);
          }

          if (valueTo) {
            // Se o valor atual ultrapassou o valor necessário, mostrar o valor atual em ambos
            const displayValue = current >= target ? current : target;
            valueTo.textContent = utils.formatCurrency(displayValue);
          }

          // Atualizar o texto da dica baseado no progresso
          const tipElement = document.querySelector(SELECTORS.freeShippingTip);
          if (tipElement && (freeShippingLabel || freeShippingLabelSuccess)) {
            // Se alcançou ou ultrapassou o valor mínimo, mostrar mensagem de sucesso
            if (current >= target && freeShippingLabelSuccess) {
              tipElement.innerHTML = freeShippingLabelSuccess;
            } else if (freeShippingLabel) {
              // Senão, mostrar mensagem normal
              tipElement.innerHTML = freeShippingLabel;
            }
          }
        }
      };

      // Inicialização de eventos
      const initEvents = () => {
        const { SELECTORS } = CONFIG;

        $(document).on('click', '.shipping--value', e => {
          e.preventDefault();
          utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active');
        });

        const cartShippingClose = document.querySelector(SELECTORS.shippingClose);
        const cartShippingOverlay = document.querySelector(SELECTORS.shippingOverlay);
        if (cartShippingClose && cartShippingOverlay) {
          [cartShippingClose, cartShippingOverlay].forEach(el =>
            el.addEventListener('click', () =>
              utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active', false)
            )
          );
        }

        $(SELECTORS.shippingForm).on('submit', handleShippingSubmit);
        bindCouponEvents();

        bindAjaxComplete();
      };

      // Renderização de item do carrinho
      const renderCartItem = (item, deleteId) => {
        const brand = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
        const price = utils.formatCurrency(item.unit_price);
        const variation = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
        const giftClass = item.is_gift ? 'is-gift' : '';

        // Renderizar itens do kit se for um kit
        let kitItems = '';
        let kitDataAttribute = '';
        if (item.kit_items && item.kit_items.length > 0) {
          // Filtrar apenas os itens selecionados (selected: true)
          const selectedKitItems = item.kit_items.filter(kitItem => kitItem.selected === false);

          kitItems = selectedKitItems.map(kitItem => {
            // Usar variation_id se disponível, senão usar id
            const kitItemId = kitItem.variation_id || kitItem.id;
            return `<p class="cart-item-content-kit-item" data-kit-item="${kitItemId}">${kitItem.name}</p>`;
          }).join('');
          kitDataAttribute = 'data-kit="true"';
        }

        const el = document.createElement('li');
        el.className = `cart-item ${giftClass}`;
        el.setAttribute('data-product-id', item.original_id);
        el.innerHTML = `
          <figure><img src="${item.image_medium}" alt="${item.name}"></figure>
          <div class="cart-item-content">
            ${brand}
            <h4 class="cart-item-content-name" ${kitDataAttribute}>${item.name}</h4>
            ${kitItems}
            <p class="cart-item-content-price">${price}</p>
            ${variation}
            <div class="variation-quantity">
            ${item.options.length > 0 ? `
              <select class="variation-select" data-original-id="${item.original_id}">
                ${item.options.map(opt => `
                  <option 
                    value="${opt.product_id}" 
                    ${opt.product_id == item.original_id ? 'selected' : ''} 
                    ${!opt.available ? 'disabled' : ''}>
                      ${opt.value}
                  </option>
                `).join('')}
              </select>
            ` : ''}
              <div class="group-quantity">
                <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                <span class="qtd-value">${item.quantity}</span>
                <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
              </div>
              <button class="delete-item-button" data-original-id="${deleteId}"></button>
            </div>
            
          </div>
        `;
        return el;
      };

      // Atualização dos contadores
      const updateCartCounters = (count, total, discount) => {
        const { SELECTORS } = CONFIG;
        const subtotal = Number(total) + Number(discount);

        document.querySelectorAll(SELECTORS.counters).forEach(el => {
          el.textContent = String(count).padStart(2, '0');
        });

        const elSubtotal = document.querySelector(SELECTORS.subtotal);
        if (elSubtotal) {
          elSubtotal.textContent = utils.formatCurrency(subtotal);
        }

        const elDuscount = document.querySelector(SELECTORS.discounts);
        if (elDuscount) {
          elDuscount.textContent = utils.formatCurrency(discount);
        }

        document.querySelector(SELECTORS.total).textContent = utils.formatCurrency(total);
      };

      // Vinculação de eventos do carrinho
      const bindCartEvents = () => {
        document.querySelectorAll('.delete-item-button').forEach(btn => {
          btn.onclick = () => deleteCartItem(btn.dataset.originalId);
        });

        document.querySelectorAll('.btn-increase').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            updateItemQuantity(btn.dataset.product, qtd + 1);
          };
        });

        document.querySelectorAll('.btn-decrease').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            qtd > 1
              ? updateItemQuantity(btn.dataset.product, qtd - 1)
              : deleteCartItem(btn.dataset.product);
          };
        });

        document.querySelectorAll('.variation-select').forEach(select => {
          select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            const newProductId = selectedOption.value;

            const cartItemEl = this.closest('.cart-item-content');
            const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);

            const cartItem = this.closest('.cart-item');
            const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
            const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');

            if (!itemId || !currentProductId || !newProductId) {
              console.error('IDs insuficientes para processar troca de variação.');
              return;
            }

            const payload = [{
              addon_values: "[]",
              as_free: false,
              is_buying_by_measure: false,
              item_id: itemId,
              product: currentProductId,
              new_product: newProductId,
              quantity: currentQty,
              replace_quantity: true
            }];

            $.ajax({
              type: 'POST',
              url: '/api/front/cart/items/?version=2',
              headers: { 'Content-Type': 'application/json' },
              dataType: 'json',
              data: JSON.stringify(payload)
            }).done(function (data) {
              if (data && data.cart_data && data.result) {
                updateCartPreview(data);
                select.setAttribute('data-original-id', newProductId);
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {
              console.error('Erro ao trocar variação:', errorThrown);
              alert('Erro ao trocar o tamanho do produto.');
            });
          });
        });
      };

      // Atualização da pré-visualização do carrinho
      const updateCartPreview = (data) => {
        const { SELECTORS } = CONFIG;
        const container = document.querySelector(SELECTORS.cartPreview);
        if (!container) return;

        // Salva o cart_id globalmente
        cartId = data.cart_data.cart_id;

        const currentTotal = data.cart_data.total_without_shipping || data.cart_data.total;
        const freeShippingTarget = data.cart_data.free_shipping_target;

        // Esconde a barra de frete grátis se o target for '0' ou 0
        const freeShippingBar = document.querySelector('.cart-preview-free-shipping');
        if (freeShippingTarget === '0' || freeShippingTarget === 0) {
          if (freeShippingBar) freeShippingBar.style.display = 'none';
        } else if (freeShippingTarget) {
          if (freeShippingBar) freeShippingBar.style.display = '';
          utils.updateFreeShippingProgress(
            currentTotal,
            freeShippingTarget,
            data.cart_data.free_shipping_label,
            data.cart_data.free_shipping_label_success
          );
        }

        const list = container.querySelector(SELECTORS.itemsList);
        list.innerHTML = '';

        data.cart_data.items.forEach((item, index) => {
          const deleteId = data.result[index]?.id;
          list.appendChild(renderCartItem(item, deleteId));
        });

        updateCartCounters(data.result.length, data.cart_data.total, data.cart_data.total_discount);
        bindCartEvents();

        if (data.cart_data.coupon) {
          $(SELECTORS.couponInput).val(data.cart_data.coupon);
          $(SELECTORS.removeCoupon).addClass('active');
        }



        utils.updateFooterUtilsHeight(true);
      };

      // Recarregar pré-visualização
      const reloadCartPreview = () => {
        utils.ajaxRequest('GET', CONFIG.CART_ENDPOINT)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          });
      };

      // Remover item do carrinho
      const deleteCartItem = (id) => {
        utils.ajaxRequest('DELETE', '/api/front/cart/items/remove', [{ id }])
          .done(reloadCartPreview)
          .fail(err => console.log('Erro ao remover item do carrinho:', err));
      };

      // Atualizar quantidade do item
      const updateItemQuantity = (originalId, newQty) => {
        // Encontrar o elemento do carrinho correspondente
        // Primeiro tenta pelo data-product-id, depois pelo botão que tem o data-product
        let cartItem = document.querySelector(`.cart-item[data-product-id="${originalId}"]`);

        if (!cartItem) {
          // Se não encontrou, procura pelo botão que tem o data-product correspondente
          const button = document.querySelector(`.btn-increase[data-product="${originalId}"], .btn-decrease[data-product="${originalId}"]`);
          if (button) {
            cartItem = button.closest('.cart-item');
          }
        }

        console.log('Procurando elemento do carrinho para ID:', originalId);
        console.log('Elemento encontrado:', cartItem);
        if (!cartItem) return;

        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        // Verificar se é um kit
        const kitNameElement = cartItem.querySelector('.cart-item-content-name[data-kit="true"]');
        if (kitNameElement) {
          console.log('Kit detectado, coletando itens do kit...');
          // Coletar os IDs dos itens do kit (já filtrados e com variation_id quando disponível)
          const kitItemElements = cartItem.querySelectorAll('.cart-item-content-kit-item');
          const products_items_kit = Array.from(kitItemElements).map(element => ({
            product: element.getAttribute('data-kit-item')
          }));

          console.log('IDs dos itens do kit:', products_items_kit);

          // Adicionar os IDs dos itens do kit ao payload
          payload[0].products_items_kit = products_items_kit;
        }

        utils.ajaxRequest('POST', CONFIG.CART_ENDPOINT, payload)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          })
          .fail(jqXHR => {
            const data = jqXHR.responseJSON;
            if (Array.isArray(data) && data[0]?.stock) {
              alert(`O produto "${data[0].stock.product.name}" possui ${data[0].stock.quantity} unidade(s) em estoque.`);
            } else {
              alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
            }
            console.log('Erro ao atualizar quantidade');
          });
      };

      // Vincular eventos de cupom
      const bindCouponEvents = () => {
        const { SELECTORS } = CONFIG;

        // Submit do cupom
        $('#js_form_coupon').on('submit', function (e) {
          e.preventDefault();
          const $form = $(this);
          const coupon = $form.find("input[name='coupon']").val();

          utils.ajaxRequest('PUT', '/api/front/cart/coupon/', { coupon })
            .done(() => {
              $(SELECTORS.removeCoupon).addClass('active');
              $form.removeClass('error').addClass('green').remove('invalid');
              // Recarregar a pré-visualização do carrinho para atualizar os valores
              reloadCartPreview();
            })
            .fail(() => {
              $form.removeClass('green').addClass('error').addClass('invalid');
            });
        });

        // Remoção do cupom
        $(SELECTORS.removeCoupon).on('click', function (e) {
          e.preventDefault();
          const $form = $('#js_form_coupon');

          utils.ajaxRequest('DELETE', '/api/front/cart/coupon/')
            .done(() => {
              $(SELECTORS.couponInput).val('');
              $(SELECTORS.removeCoupon).removeClass('active');
              $form.removeClass('green');
              reloadCartPreview();
            });
        });

        // Clique no input do cupom remove classes do form
        $('#js_form_coupon input[name="coupon"]').on('focus', function () {
          const $form = $('#js_form_coupon');
          $form.removeClass('green error invalid');
        });

      };

      // Manipular envio de frete
      const handleShippingSubmit = (e) => {
        e.preventDefault();
        const { SELECTORS } = CONFIG;
        const cep = $(SELECTORS.cepInput).val().replace(/['"]/g, ''); // Remove aspas simples ou duplas
        localStorage.setItem('cep', cep);

        const $loading = $('.shipping-loading');
        $loading.show();

        $.ajax({
          type: 'POST',
          url: '/produto/get-produto-frete/',
          data: { cep, show_delivery_shippings: true }, // Envia como form data, sem JSON
          dataType: 'json'
        }).done(data => {
          const shippings = data.shippings.shippings_available.shippings;
          const list = document.querySelector(SELECTORS.shippingList);
          if (!list) return;

          const hasMultiple = shippings.length > 1;

          const itemsHTML = shippings.map((s, i) => {
            let date = '';
            if (s.estimated_delivery_date != null && s.estimated_delivery_date !== '') {
              const [ano, mes, dia] = s.estimated_delivery_date.split('-');
              date = `${dia}/${mes}/${ano}`;
            }
            const cost = s.cost_label;

            return `
      <li class="cart-preview__shipping__list--item"
          data-index="${i}"
          data-shipping-id="${s.company_id}"
          data-shipping-cost="${cost}"
          data-shipping-name="${s.name}"
          data-shipping-price="${s.cost}"
          ${i > 0 ? 'style="display: none;"' : ''}>
        <div>
          <span>${s.name}</span>
          <span class="shipping--value">${cost}</span>
          <p>${s.delivery_time_days} ${s.label_delivery_time_days_checkout}</p>
          <p>Previsão ${date}</p>
        </div>
      </li>
    `;
          }).join('');

          const toggleBtn = hasMultiple
            ? `<button type="button" class="show-more-shippings" style="margin-top: 10px;">Ver mais opções de frete</button>`
            : '';

          list.innerHTML = itemsHTML + toggleBtn;

          requestAnimationFrame(() => {
            utils.updateFooterUtilsHeight(false);
          });

          if (hasMultiple) {
            const button = list.querySelector('.show-more-shippings');
            button?.addEventListener('click', () => {
              list.querySelectorAll('.cart-preview__shipping__list--item').forEach((li, i) => {
                if (i > 0) li.style.display = '';
              });
              button.style.display = 'none';
              utils.updateFooterUtilsHeight(false);
            });
          }
        })
          .fail(() => {
            alert('Erro ao calcular frete. Tente novamente.');
          })
          .always(() => {
            $loading.hide();
          });

      };

      // Vincular evento de conclusão de AJAX
      const bindAjaxComplete = () => {
        $(document).on("ajaxComplete", (event, xhr, settings) => {
          let payload = null;

          try {
            if (typeof settings.data === 'string') {
              payload = JSON.parse(settings.data);
            }
          } catch (err) {
            console.warn('settings.data não é um JSON válido:', settings.data);
            return; // early return para evitar seguir com payload inválido
          }

          const isReplacingQty = Array.isArray(payload) && payload[0]?.replace_quantity;

          if (
            settings.url.includes(CONFIG.CART_ENDPOINT) &&
            settings.type === 'POST' &&
            xhr.responseJSON?.result
          ) {
            reloadCartPreview();
            if (!isReplacingQty) {
              $('.header__second--tools-cart-preview').addClass('active');
              $('.shoppub-fast-buy-popup').removeClass('active');
              document.body.classList.add('no-scroll');
              document.documentElement.classList.add('no-scroll');
            }
          }
        });
      };


      // Inicialização
      reloadCartPreview();
      initEvents();
    },
  },
  mounted() {
    this.cartPreview();

    const allTitles = document.querySelectorAll('.cart-preview__footer-utils li');
    if (allTitles.length > 0) {
      allTitles.forEach(li => {
        const open = li.querySelector('.cart-preview__footer-utils--title');
        const toggleBtn = li.querySelector('.open-close');
        if (open && toggleBtn) {
          open.addEventListener('click', () => {
            li.classList.toggle('active');
            toggleBtn.classList.toggle('active');
          })
        }
      })
    }
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

document.addEventListener("DOMContentLoaded", function () {
  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  if (tabAccordions) {
    tabAccordions.forEach(function (tabAccordion, index) {
      tabAccordion.addEventListener('click', function () {
        tabAccordions.forEach(function (tab) {
          tab.classList.remove('active');
        });

        contentAccordions.forEach(function (content) {
          content.classList.remove('active');
        });

        tabAccordion.classList.add('active');
        contentAccordions[index].classList.add('active');
      });
    });
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  // Accordion pagina dinamica
  const accordionItems = document.querySelectorAll("span#accordion-item");

  // Adiciona evento de clique para cada item
  if (document.body.id === "dynamic-page-extra" && accordionItems) {
    accordionItems.forEach(item => {
      item.addEventListener("click", function () {
        // Adiciona classe 'active' ao item clicado
        item.classList.toggle("active");

        // Seleciona o próximo elemento (o irmão seguinte) e adiciona 'active'
        const content = item.nextElementSibling;
        if (content && content.classList.contains("op-accordion__content")) {
          content.classList.toggle("active");
        }
      });
    });
  }

  waitForElementToExist('#dynamic-page-extra .quem-somos__content--brands').then(element => {
    $('.quem-somos__content--brands ul').slick({
      arrows: false,
      dots: false,
      infinite: false,
      mobileFirst: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      responsive: [
        {
          breakpoint: 993,
          settings: {
            slidesToShow: 4,
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 1275,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 6,
          }
        }
      ]
    });
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);
});